import {StTagStateType} from 'module/StTag/reducer/StTagReducer';

export const selStTagById = (state: StTagStateType) => state.StTag.byId;
export const selStTagAllIds = (state: StTagStateType) => state.StTag.allIds;
export const selStTagLastRefresh = (state: StTagStateType) => state.StTag.lastRefresh